/**
 * Home Preloader — hide logic (loaded with defer)
 *
 * ACTIVATION is handled by an inline <script> in snippets/home-preloader.liquid.
 * Timing is based on data-activated-at (when the overlay became active), not
 * navigation start, so minimum/maximum visible durations match merchant settings.
 */

(function () {
  var el = document.getElementById('home-preloader');

  if (!el || !el.hasAttribute('active')) return;
  var overlay = el;

  var SESSION_KEY = 'home-preloader-shown';

  var SKIP_IF_UNDER_MS = Number(el.dataset.skipThreshold) || 300;
  var MIN_VISIBLE_MS = Number(el.dataset.minVisible) || 800;
  var MAX_VISIBLE_MS = Number(el.dataset.maxVisible) || 2500;
  var FADE_DURATION_MS = Number(el.dataset.fadeDuration) || 400;
  var isPreviewMode = el.dataset.previewMode === 'true';

  overlay.style.setProperty('--preloader-fade-duration', FADE_DURATION_MS + 'ms');

  var hidden = false;

  function hide() {
    if (hidden) return;
    hidden = true;

    if (!isPreviewMode) sessionStorage.setItem(SESSION_KEY, '1');

    document.documentElement.removeAttribute('scroll-lock');

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    overlay.setAttribute('hiding', '');

    function removeEl() {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }

    if (reducedMotion) {
      removeEl();
    } else {
      overlay.addEventListener('animationend', removeEl, { once: true });
      setTimeout(removeEl, FADE_DURATION_MS + 100);
    }
  }

  if (isPreviewMode) return;

  var activatedAt = Number(el.dataset.activatedAt);
  if (!activatedAt) {
    activatedAt = Date.now();
    el.dataset.activatedAt = String(activatedAt);
  }

  var visibleMs = Date.now() - activatedAt;

  // Hard cap from when the overlay was shown.
  setTimeout(hide, Math.max(0, MAX_VISIBLE_MS - visibleMs));

  // Minimum dwell from when the overlay was shown.
  setTimeout(hide, Math.max(0, MIN_VISIBLE_MS - visibleMs));
})();
